import ResultDetails from './ResultDetails';

export default ResultDetails;
